import * as React from "react";

function SvgCalculator(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}><path d="M12.444 0H1.556C.7 0 0 .7 0 1.556v10.888C0 13.3.7 14 1.556 14h10.888C13.3 14 14 13.3 14 12.444V1.556C14 .7 13.3 0 12.444 0zm-1.096 1.556l-9.792 9.792V1.556h9.792zM2.652 12.444l9.792-9.792v9.792H2.652zm-.319-9.333h3.89v1.167h-3.89V3.11zm7.778 4.278H8.944v1.555H7.39v1.167h1.555v1.556h1.167V10.11h1.556V8.944H10.11V7.39z" /></svg>;
}

export default SvgCalculator;